<template>
    <div>
        <mercur-spinner v-if="!items"></mercur-spinner>
        <pretty-select
            data-test="agreementProductSelect"
            v-if="items"
            placeholder="Select products"
            label="productName"
            :options="items"
            v-model="selectedProduct"
            :required="required"
            :reduce="reducedPayload"
            :multiple="multiple"
            :disabled="disabled"
        ></pretty-select>
    </div>
</template>

<script>
import PrettySelect from '../../components/utils/PrettySelect'
import CONFIG from '@root/config'

export default {
    name: 'AgreementProductSelect',
    components: { PrettySelect },
    data () {
        return {
            items: null,
        }
    },
    props: {
        required: {
            default: false,
        },
        agreementId: {
            default: null,
            required: true,
        },
        returnField: {
            default: null,
        },
        multiple: {
            default: null,
        },
        product: {
            default: null,
        },
        disabled: {
            default: false,
        },
        categories: {
            default: () => [],
        },
    },
    model: {
        prop: 'product',
        event: 'productChange',
    },
    watch: {
        agreementId: {
            handler () {
                this.getProducts()
            },
            immediate: true,
        },
        categories: {
            handler () {
                this.getProducts()
            },
        },
    },
    computed: {
        selectedProduct: {
            get () {
                if (!this.product && this.multiple) {
                    return null
                }
                return this.product
            },
            set (value) {
                this.$emit('productChange', value)
            },
        },
        reducedPayload () {
            if (this.returnField) {
                return (e) => e[this.returnField]
            }

            return e => e
        },
    },
    methods: {
        getProducts () {
            if (!this.isAllowedTo('getAgreementProductsByAgreementId')) {
                return
            }
            const url = CONFIG.API.ROUTES.AGREEMENTS.GET_PRODUCTS.replace('{agreementId}', this.agreementId)
            const requestPayload = JSON.parse(JSON.stringify(CONFIG.API.REQUEST_DEFAULT))

            if (this.categories.length) {
                requestPayload.categories = this.categories
            }

            this.addJob(url)
            this.items = null
            this.$api.post(url, requestPayload).then(({ data }) => {
                this.items = data.data.items
                this.$emit('fetched', this.items)
            }).catch(err => {
                this.$root.$emit('notification:global', {
                    message: err,
                    type: 'error',
                })
            }).finally(() => {
                this.finishJob(url)
            })
        },
    },
}
</script>
